import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  fileId: string().required(),
})

export const url = ({ fileId }) => `/v1/policies/${fileId}`
